<tcm-main-frame [isLoading]="isLoading" titleKey="Screens.UserDefaultInfo.Title">
    <ng-container commands *ngIf="viewModel?.form">
      <button class="btn btn-success me-2"
              (click)="save()">{{'Common.SearchActionsAndDetailsActions.Save' | translate}}</button>
      <button class="btn btn-default me-4"
              (click)="logout()">{{'Screens.UserDefaultInfo.Actions.Logout' | translate}}</button>
    </ng-container>
    <ng-container body>
      <tcm-details-layout>
        <div *ngIf="viewModel?.form" form-area>
          <form #detailsForm="ngForm">
            <div class="tcm-details-panel">
              <div class="row">
                <div class="col-md-4">
                    <waf-select-input name="defaultClinicId"
                                    [label]="'Screens.UserDefaultInfo.Fields.DefaultClinic' | translate"
                                    [(ngModel)]="viewModel.form.defaultClinicId"
                                    [options]="viewModel.clinicOptions"
                                    [required]="true"></waf-select-input>
                </div>
              </div>
            </div>
          </form>
        </div>
      </tcm-details-layout>
    </ng-container>
  </tcm-main-frame>